import React, { useState, useEffect } from 'react';
import PageRenderer from '../components/renderer/PageRenderer';
import SettingsLoader from '../components/common/SettingsLoader';
import { useAuth0 } from '@auth0/auth0-react';
import { apiPath } from "../config";
import { useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Container, Row } from 'react-bootstrap';
import SimpleHeader from '../components/SimpleHeader';
import MainAppWrap from '../Layout/MainAppWrap';
import Footer from '../components/Footer';

interface Schema {
    header?: {
        logo_url?: string;
        title?: string;
    };
    [key: string]: any;
}

const RecommendationDetail: React.FC = () => {
    const { recommendation_id } = useParams<{ recommendation_id: string }>();
    const { user, getIdTokenClaims } = useAuth0();
    const [schema, setSchema] = useState<Schema | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const fetchSchema = async (): Promise<void> => {
        try {
            const claims = await getIdTokenClaims();
            const idToken = claims?.__raw;
            const options: RequestInit = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json",
                },
            };
            const path = `/admin/v1/pages/read/recommendations_details_admin?recommendation_id=${recommendation_id}`;
            const url = `${apiPath()}${path}`;
            const response = await fetch(url, options);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = await response.json();
            setSchema(result);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching recommendation details schema:', error);
        }
    };

    useEffect(() => {
        if (user && schema === null) {
            fetchSchema();
        }
    }, [user, recommendation_id]);

    return (
        <div>
            <MainAppWrap>
                <div className="main-content">
                    {schema?.header ? (
                        <SimpleHeader logo={schema?.header?.logo_url} title={schema?.header?.title} />
                    ) : (
                        <SimpleHeader />
                    )}
                    <Container fluid="xxl" className="">
                        <Row>
                            <div className="page-container">
                                {isLoading ? <SettingsLoader /> : <PageRenderer schema={schema} />}
                            </div>
                        </Row>
                    </Container>
                </div>
                <ToastContainer />
                <Footer />
            </MainAppWrap>
        </div>
    );
};

export default RecommendationDetail;

